import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Delivery DateTime Cell Renderer
 *
 * Displays formatted delivery date and time in smart-grid tables.
 * Format: dd-MM-yyyy HH:mm:ss
 *
 * @example
 * ```typescript
 * {
 *   field: 'deliveryDateTime',
 *   headerName: 'Fecha y Hora de Entrega',
 *   cellRenderer: DeliveryDateTimeCellRendererComponent,
 *   minWidth: 180
 * }
 * ```
 */
@Component({
  selector: 'app-delivery-datetime-cell-renderer',
  standalone: true,
  imports: [CommonModule, DatePipe],
  template: `
    <span class="text-sm whitespace-nowrap">
      {{ formattedDateTime }}
    </span>
  `,
})
export class DeliveryDateTimeCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get formattedDateTime(): string {
    const dateTime = this.params.data?.deliveryDateTime;
    if (!dateTime) return '-';

    const pipe = new DatePipe('en-US');
    return pipe.transform(dateTime, 'dd-MM-yyyy HH:mm:ss') ?? '-';
  }
}
